export default "__VITE_ASSET__DISw93Od__"